import { posthog } from './posthog'

/**
 * Typed analytics helpers for the Bandos app.
 * All PostHog event names are defined here — never scatter posthog.capture() calls.
 */
export const analytics = {
  projectCreated: (props: { title: string }) => posthog.capture('project_created', props),

  mindmapOpened: (props: { mindmap_id: string }) => posthog.capture('mindmap_opened', props),

  reportViewed: (props: { mindmap_id: string }) => posthog.capture('report_viewed', props),

  surveyShared: (props: { node_id: string; method: 'copy_link' | 'email' }) =>
    posthog.capture('survey_shared', props),

  surveyResponseSubmitted: (props: {
    node_id: string
    duration_seconds: number
    question_count: number
  }) => posthog.capture('survey_response_submitted', props),

  interviewConducted: (props: {
    node_id: string
    duration_seconds: number
    question_count: number
  }) => posthog.capture('interview_conducted', props),

  upgradePageViewed: (props: { context: 'onboarding' | 'direct' }) =>
    posthog.capture('upgrade_page_viewed', props),

  upgradeCompleted: () => posthog.capture('upgrade_completed'),
}
